// Note: katex.min.css is imported globally in app/globals.css
import { MarkdownComponent as Markdown } from 'pengi-ui';

interface MarkdownComponentProps {
  content: string | null | undefined;
  textStyle?: React.CSSProperties;
}

const MarkdownComponent = ({ content, textStyle }: MarkdownComponentProps) => {
  if (!content) {
    return null;
  }

  const finalTextStyle: React.CSSProperties = {
    fontFamily: 'var(--font-display)',
    color: '#454C5C',
    textAlign: 'left',
    fontSize: '16px',
    ...textStyle,
  };

  return (
    <Markdown content={content} textStyle={finalTextStyle} tableStyle={{ margin: '0 auto', fontSize: '16px' }} />
  );
};

export default MarkdownComponent;
